module.exports = __webpack_public_path__ + "static/1-ba341fb673e5b341f2c98a68191c660c.jpg";